import enLocale from 'element-ui/lib/locale/lang/en'
const en = {
  message: {
    login: 'login',
    register: 'register',
    forgetPwd: 'Forget Password',
    getVerificationCode: 'getcaptcha',
    createExm: 'create the examination',
    inputPwd: 'please input the password',
    examAnnouncemen: "examAnnouncement",
    more:"more",
    announcemen: "announcemen",
    switchLanguage:"Are you sure to switch languages?",
    releaseTime:"time",
    reSend:"resend",
    read:"read",
    prev:"prev",
    next:"next"
  },
  sidebar: {
    myApplication: 'My Application',
    myAppointment: 'My Appointment',
    myExemption: 'My Exemption',
    myInvoice: 'My Invoice',
    personalInformation: 'Personal Information',
    accountSecurity: 'Account Security',
    helpCenter: 'Help Center',
    freeCommitment: "freeCommitment",
    selectBatch: "selectBatch"
  },
  header: {
    home: 'Home',
    registrationExam: 'Registration Exam',
    registrationXjncxys: 'Registration Exam',
    appointmentTestSite: 'Appointment test site',
    exemptionApplication: 'Exemption application',
    admissionTicketPrinting: 'Admission ticket printing',
    resultInquiry: 'Result inquiry',
    noticeAnnouncemen: "noticeAnnouncemen",
  },
  common:{
    nextStep:"nextStep",
    tip:"tip",
    confirm:"confirm",
    enterCode:"enter the code",
    remark: "remark",
    operation:"operation",
    cancel:"cancel"
  },
  login: {
    accountLogin: "accountLogin",
    phoneLogin: "phoneLogin",
    findPwd:"findPwd",
    register:"register",
    login:"login",
    idNumber:"ID Number",
    pwd:"pwd",
    verificationCode:"verificationCode",
    phoneNum:"phoneNum",
    phoneCode:"phoneCode",
    emailCode:"emailCode",
    welcome:"welcome",
    signOut:"signOut"
  },
  register:{
    regTitle:"User registration / authentication",
    accVerification:"accVerification",
    improveInformation:"information",
    success:"success",
    selectMethod:"Please select the verification method",
    phoneVerification:"phoneVerification",
    emailVerification:"emailVerification",
    existingAccount:"existingAccount",
    logIn:"Log in now",
    email:"email",
    fillRealName:"fill in the real name",
    IDType:"ID Type",
    fillIDNumber:"fill in the ID number",
    loginPwd:"loginPwd",
    confirmPwd:"confirmPwd",
    agree:"agree",
    manmal:"user manual",
    regcomplete:"register success",
    successTip1:"You can use the mobile number or certificate number you filled in when registering to complete the login.",
    successTip2:"After your information changes, please log in to the platform to update your personal information in time.",
    successTip3:"Please make sure the account is secure. Forget the password and use the bound mobile number or email to retrieve it",
    back:"Back to home",
    enterPhoneNum:"Please enter your mobile number",
    worngPhoneNum:"please input the correct number",
    worngEmail:"please input the correct email",
    phoneRegistered:"the mobile number has been registered",
    emailRegistered:"the email has been registered",
    enterEmail:"please enter email",
    enterAccount:"Please enter 6-26 letters + numbers, the first must be a letter",
    accRegistered:"This account has been occupied, please re-enter",
    pwdlimit:"Please enter 6-26 digits, letters or special characters",
    confirmPwdAgain:"Please confirm the password again",
    confirmPwdWrong:"Confirm the password is wrong, please re-enter",
    wrongId:"please input the correct certificate number",
    selectIdType:"please select a document type",
    idRegistered:"ID number has been registered",
    enterName:"please enter name",
    agreeManual:"Please read and agree to the ATA User Manual",
  },
  findPwd:{
    retrievePwd:"retrieve password",
    phoneReset:"phone reset",
    emailReset:"mailbox reset",
    confirmChangePwd:"Confirm change password",
    noBindPhone:"The phone number is not bound to the user, please re-enter",
    noBindEmail:"There is no user bound to this mailbox, please re-enter",
    changePwdSuccess:"password changed success"
  },
  examRegisteation:{
    closeTip:"The registration is not open yet, and the application operation is temporarily unavailable.",
    batchName: "batchName",
    ExamTime:"ExamTime",

  },
   print: {
    payAttention:"The admission ticket printing is not yet open, please pay attention to the registration notice, in order to understand the opening time of the admission ticket printing in time.",
    begin_time:"The admission ticket printing is not yet open. The opening hours are from ",
    to:"to",
    takeTheExam:". When you take the exam, you need to take the ID card and the admission ticket to take the exam.",
    suspendPrint:"The admission ticket printing has been suspended. Please pay attention to the test announcement to understand the opening hours of the admission ticket printing.",
    print:"print",
    noPrintable:"There is no printable admission ticket for the time being.",
    ExamSiteMap:"site map",
    nothing:"/",
  },
  grade: {
    gradeQuery: "Results query is not open yet"
  },
  ...enLocale
}

export default en